import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {

  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  maintenanceBg: string = this.siteUrlPath + "/" + this.mediaUrlPath + "/maintenance_bg.png";


  
  constructor() { 
    
  }

}
